import React, { Fragment, useEffect, useState } from "react";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { set_loading } from "../../../redux/actions/LayoutAction";
import { connect } from "react-redux";
import "./dashboard.scss";

const DashBoard = (props) => {
  const [data, setData] = useState(false);
  const [values, setValues] = useState([]);
  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    document.title = "Dashboard";
  }, []);

  useEffect(() => {
    apiJson.dashboard.getDashboardData().then((response) => {
      if (response.success) {
        setValues(response.data);
        setData(true);
      } else if (!response.status) {
        setData(true);
        // eslint-disable-next-line
        // message = response.message
        //   ? response.message !== ""
        //     ? response.message
        //     : "something went wrong"
        //   : "something went wrong";
        // showError();
      } else {
        setData(true);
        // if (response.status >= 400 && response.status < 500) {
        //   message = response.message
        //     ? response.message
        //     : response.errors
        //     ? response.errors
        //     : "something went wrong";
        //   showError();
        // } else {
        //   message = response.message
        //     ? response.message !== ""
        //       ? response.message
        //       : "something went wrong"
        //     : "something went wrong";
        //   showError();
        // }
      }
    });
  }, []);

  // eslint-disable-next-line
  // useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right dashboard-page-desktop">
        {data && (
          <div className="right-content">
            <div className="content-container">
              <div className="content-wrapper">
                <div className="dashboard-row d-flex flex-wrap">
                  <div className="dashboard">
                    <div className="dashboard-card">
                      <div className="dasboard-header-row d-flex justify-content-center align-items-center">
                        <div className="dashboard-heading">Total Revenue</div>
                      </div>
                      <div className="dashboard-body-row d-flex justify-content-center align-items-center">
                        <div className="value">
                          {values && values.total_revenue && (
                            <span className="me-2 text-uppercase">
                              {values.total_revenue.currency}
                            </span>
                          )}
                          {values &&
                            values.total_revenue &&
                            values.total_revenue.amount}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dashboard">
                    <div className="dashboard-card">
                      <div className="dasboard-header-row d-flex justify-content-center align-items-center">
                        <div className="dashboard-heading">New Orders</div>
                      </div>
                      <div className="dashboard-body-row d-flex justify-content-center align-items-center">
                        <div className="value">
                          {values && values.new_orders}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="dashboard">
                    <div className="dashboard-card">
                      <div className="dasboard-header-row d-flex justify-content-center align-items-center">
                        <div className="dashboard-heading">Total Orders</div>
                      </div>
                      <div className="dashboard-body-row d-flex justify-content-center align-items-center">
                        <div className="value">
                          {values && values.all_orders}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = { set_loading };

export default connect(mapStateToProps, mapDispatchTopProps)(DashBoard);
